import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import styles from './index.module.scss';
import classNames from 'classnames';

const NextAction = ({
  onClick,
  disabled,
  type,
  isSubmitting,
  btnText,
  btnClassName,
  testid,
}: {
  onClick?(): void;
  disabled?: boolean;
  type?: 'submit' | 'button';
  isSubmitting?: boolean;
  btnText?: string;
  btnClassName?: string;
  testid?: string;
}) => (
  <Button
    data-testid={testid || 'proceed-btn'}
    type={type}
    color="primary"
    onClick={onClick}
    disabled={disabled}
    className={classNames(
      'font-semibold',
      styles.btn,
      styles.nextBtn,
      btnClassName ? btnClassName : styles.customWidth,
    )}
    variant="contained"
  >
    {isSubmitting ? (
      <CircularProgress size={20} color="inherit" />
    ) : btnText ? (
      btnText
    ) : (
      <>Continue</>
    )}
  </Button>
);

export default NextAction;
